"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _settings = require("../settings.js");
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _style = _interopRequireDefault(require("./style.css"));
var _rowActions = _interopRequireDefault(require("../rowActions"));
var _standalone = _interopRequireDefault(require("prettier/standalone"));
var _parserGraphql = _interopRequireDefault(require("prettier/parser-graphql"));
var _helpers = require("../helpers.js");
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var prettify = function prettify(code) {
  return _standalone["default"].format(code, {
    parser: 'graphql',
    plugins: [_parserGraphql["default"]]
  });
};
var Fortress = window.cccisd.fortress;
var totalTypes = [{
  value: 'avg',
  label: 'Average',
  defaultHeader: 'Average:'
}, {
  value: 'sum',
  label: 'Sum',
  defaultHeader: 'Total:'
}];
var validate = function validate(values) {
  var errors = {};
  if (values.extraQuery) {
    try {
      prettify("query { ".concat(values.extraQuery, " }"));
    } catch (e) {
      errors.extraQuery = 'Wrong syntax';
    }
  }
  values.variables.forEach(function (variable, index) {
    if (!variable.name) {
      errors["variables.".concat(index, ".name")] = 'Name is required';
    } else if (!/^\w+$/.test(variable.name)) {
      errors["variables.".concat(index, ".name")] = 'Wrong name';
    }
    if (!variable.type) {
      errors["variables.".concat(index, ".type")] = 'Type is required';
    } else if (!/^\w+$/.test(variable.type) && !/^\[\w+\]$/.test(variable.type)) {
      errors["variables.".concat(index, ".type")] = 'Wrong type';
    }
    if (variable.previewValue) {
      try {
        // eslint-disable-next-line no-eval
        eval("const some = ".concat(variable.previewValue, ";"));
      } catch (e) {
        errors["variables.".concat(index, ".previewValue")] = 'Wrong value';
      }
    }
  });
  values.columnRenderParams.forEach(function (prop, index) {
    if (!prop.name) {
      errors["columnRenderParams.".concat(index, ".name")] = 'Name is required';
    } else if (!/^\w+$/.test(prop.name)) {
      errors["columnRenderParams.".concat(index, ".name")] = 'Wrong name';
    }
    if (!prop.previewValue) {
      errors["columnRenderParams.".concat(index, ".previewValue")] = 'Preview value is required';
    } else {
      try {
        // eslint-disable-next-line no-eval
        eval("const some = ".concat(prop.previewValue, ";"));
      } catch (e) {
        errors["columnRenderParams.".concat(index, ".previewValue")] = 'Wrong value';
      }
    }
  });
  return errors;
};
var Component = function Component(props) {
  var settings = props.settings,
    _onSubmit = props.onSubmit,
    closeModal = props.closeModal;
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: _objectSpread(_objectSpread({}, (0, _pick2["default"])(settings, ['title', 'notes', 'perPage', 'hasIdentifiable', 'showRowNumbers', 'showTotal', 'extraQuery', 'rowActions', 'useTaskMaster'])), {}, {
      rowActions: settings.rowActions || [],
      totalType: settings.totalType || 'sum',
      totalHeader: settings.totalHeader || 'Total:',
      variables: settings.variables || [],
      columnRenderParams: settings.columnRenderParams || []
    }),
    validate: validate,
    onSubmit: function onSubmit(values) {
      _onSubmit(values);
      closeModal();
    },
    render: function render(_ref) {
      var values = _ref.values,
        setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "title",
        component: _cccisdFormik.CccisdInput,
        label: "Title",
        autoFocus: true
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "notes",
        component: _cccisdFormik.CccisdInput,
        label: "Notes"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "perPage",
        component: _cccisdFormik.CccisdSelect,
        label: "Rows per page",
        options: _settings.perPageOptions,
        style: {
          width: 'auto'
        }
      }), !!settings.projectId && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "hasIdentifiable",
        component: _cccisdFormik.CccisdToggle,
        label: "has identifiable data"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        wrapperClassName: "mb-2",
        name: "showRowNumbers",
        component: _cccisdFormik.CccisdToggle,
        label: "show row numbers"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "showTotal",
        component: _cccisdFormik.CccisdToggle,
        label: "show total row"
      }), values.showTotal && /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "totalType",
        component: _cccisdFormik.CccisdSelect,
        label: "Total type",
        options: totalTypes,
        onChange: function onChange(event) {
          var totalType = event.target.value;

          // Change header if it's a default one
          if (totalTypes.some(function (obj) {
            return obj.defaultHeader === values.totalHeader;
          })) {
            setFieldValue('totalHeader', totalTypes.find(function (obj) {
              return obj.value === totalType;
            }).defaultHeader);
          }
          setFieldValue('totalType', totalType);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "totalHeader",
        component: _cccisdFormik.CccisdInput,
        label: "Total header"
      }))), _rowActions["default"].length > 0 && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "rowActions",
        render: function render(_ref2) {
          var field = _ref2.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, "Row actions"), _rowActions["default"].map(function (action) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: action.name,
              className: "form-check",
              style: {
                margin: 0
              }
            }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
              type: "checkbox",
              name: "rowActions[]",
              onChange: function onChange() {
                setFieldValue('rowActions', (0, _xor2["default"])(field.value, [action.name]));
              },
              checked: !!field.value.includes(action.name)
            }), ' ', action.title));
          }));
        }
      }), Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Advanced settings"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "useTaskMaster",
        component: _cccisdFormik.CccisdToggle,
        label: "use Task Master for queries"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "extraQuery",
        component: _cccisdFormik.CccisdTextarea,
        label: "Additional Query",
        style: {
          height: '10em'
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "variables",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, "Query variables"), values.variables.length > 0 && /*#__PURE__*/_react["default"].createElement("table", {
            className: _style["default"].variablesTable
          }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
            width: "40%"
          }, "Name"), /*#__PURE__*/_react["default"].createElement("th", {
            width: "30%"
          }, "Type"), /*#__PURE__*/_react["default"].createElement("th", {
            width: "30%"
          }, "Preview value"), /*#__PURE__*/_react["default"].createElement("th", {
            width: "1rem"
          }, "\xA0"))), /*#__PURE__*/_react["default"].createElement("tbody", null, values.variables.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement("tr", {
              key: item.id
            }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              wrapperClassName: "",
              name: "variables.".concat(index, ".name"),
              component: _cccisdFormik.CccisdInput
            })), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              wrapperClassName: "",
              name: "variables.".concat(index, ".type"),
              component: _cccisdFormik.CccisdInput
            })), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              wrapperClassName: "",
              name: "variables.".concat(index, ".previewValue"),
              component: _cccisdFormik.CccisdInput
            })), /*#__PURE__*/_react["default"].createElement("td", {
              className: _style["default"]["delete"]
            }, /*#__PURE__*/_react["default"].createElement("span", {
              onClick: function onClick() {
                return arrayHelpers.remove(index);
              }
            }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))));
          }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-success btn-xs",
            onClick: function onClick() {
              return arrayHelpers.push({
                id: (0, _helpers.generateNewId)(values.variables),
                name: 'var',
                type: 'String',
                previewValue: '"Something"'
              });
            }
          }, "Add variable")));
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "columnRenderParams",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, "Column Render Params"), values.columnRenderParams.length > 0 && /*#__PURE__*/_react["default"].createElement("table", {
            className: _style["default"].variablesTable
          }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
            width: "40%"
          }, "Name"), /*#__PURE__*/_react["default"].createElement("th", {
            width: "60%"
          }, "Preview value"), /*#__PURE__*/_react["default"].createElement("th", {
            width: "1rem"
          }, "\xA0"))), /*#__PURE__*/_react["default"].createElement("tbody", null, values.columnRenderParams.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement("tr", {
              key: item.id
            }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              wrapperClassName: "",
              name: "columnRenderParams.".concat(index, ".name"),
              component: _cccisdFormik.CccisdInput
            })), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              wrapperClassName: "",
              name: "columnRenderParams.".concat(index, ".previewValue"),
              component: _cccisdFormik.CccisdInput
            })), /*#__PURE__*/_react["default"].createElement("td", {
              className: _style["default"]["delete"]
            }, /*#__PURE__*/_react["default"].createElement("span", {
              onClick: function onClick() {
                return arrayHelpers.remove(index);
              }
            }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))));
          }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-success btn-xs",
            onClick: function onClick() {
              return arrayHelpers.push({
                id: (0, _helpers.generateNewId)(values.columnRenderParams),
                name: 'var',
                previewValue: '"Something"'
              });
            }
          }, "Add prop")));
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonArea
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Submit")));
    }
  });
};
Component.propTypes = {
  settings: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func,
  closeModal: _propTypes["default"].func
};
var _default = exports["default"] = Component;